import React from 'react';
import { css, useTheme } from '@emotion/react';
import { legacyOnly } from 'constants/themes.constants';
import styled from 'types/theme.types';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { IconButton } from 'components/common/icon-button';
import { BaseItemContainer } from 'components/layout/navbar/navbar-panel.utils';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';

const NavbarCollapse: React.FC = () => {
  const { isCollapsed, toggleCollapsed } = useNavbarCollapse();
  const { isNewDesign } = useTheme();
  const Glyph = isCollapsed ? MenuUnfoldOutlined : MenuFoldOutlined;

  return (
    <div>
      <BaseItemContainer>
        {isNewDesign ? (
          <OnDarkIconButton
            icon={Glyph}
            size="small"
            dataE2e="navbar-collapse-toggle"
            onClick={toggleCollapsed}
            ariaLabel="toggle navigation"
          />
        ) : (
          <ToggleButton onClick={toggleCollapsed} data-e2e="navbar-collapse-toggle">
            <Glyph />
          </ToggleButton>
        )}
      </BaseItemContainer>
    </div>
  );
};

/**
 * IconButton is built for the app's light surfaces; only the colours differ on the dark rail. Doubled
 * because a plain `styled(IconButton)` class would tie with IconButton's own and be decided by order.
 */
const OnDarkIconButton = styled(IconButton)`
  && {
    color: var(--text-heading-on-dark);

    &:not(:disabled):hover {
      background-color: var(--surface-navigation-navigation-item);
      color: var(--text-heading-on-dark);
    }
  }
`;

// Switch-off only. The wrappers stay put: the parity fixture pins this rule's bytes in source order.
const ToggleButton = styled.button`
  ${legacyOnly(css`
    width: 13px;
    height: 13px;
  `)}
  border: none;
  background: transparent;
  ${legacyOnly(
    theme => css`
      color: ${theme.primaryGray};
    `
  )}
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 120ms ease-in-out;

  &:hover {
    ${legacyOnly(
      theme => css`
        background-color: ${theme.tertiaryGray};
      `
    )}
  }

  ${legacyOnly(css`
    svg {
      font-size: 14px;
    }
  `)}
`;

export default NavbarCollapse;
